import { Fragment, ReactNode } from 'react'

import { Loader } from '~/chat/Loader'
import { useAppSelector } from '~/redux/hooks'
import { selectIsFirebaseAuthenticated } from '~/auth/slices/auth.slice'

interface FirebaseAuthGuardProps {
  children: ReactNode
  hideOnly?: boolean
}

function FirebaseAuthGuard({ children, hideOnly }: FirebaseAuthGuardProps): React.ReactElement | null {
  const authenticated = useAppSelector(selectIsFirebaseAuthenticated)

  if (!authenticated) {
    if (hideOnly) {
      return null
    }
    return <Loader />
  }

  return <Fragment>{children}</Fragment>
}

export default FirebaseAuthGuard
